(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog"]) return;
  try {
    
  document.querySelectorAll('.blog-filter__item[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dose-reviews-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.dorReady) return;
    root.dataset.dorReady = '1';

    var MES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 8;

    function parseMeta(sel){
      var el = root.querySelector(sel);
      if(!el) return null;
      var t = (el.textContent || '').trim();
      if(!t) return null;
      try { var v = JSON.parse(t); if(typeof v === 'string'){ v = JSON.parse(v); } return v; }
      catch(e){ return null; }
    }

    var list = parseMeta('[data-dor-list]') || [];
    var data = parseMeta('[data-dor-data]');
    if(!Array.isArray(list) || !list.length) return;

    // solo reseñas con comentario
    var reviews = list.filter(function(r){ return r && r.c && (''+r.c).trim().length > 0; });
    // por defecto: primero 5★, luego 4★, 3★…; dentro de cada grupo, las más recientes
    function ts(r){ var d = new Date(r.d).getTime(); return isNaN(d) ? 0 : d; }
    function byStars(a,b){ return ((+b.s||0) - (+a.s||0)) || (ts(b) - ts(a)); }
    reviews.sort(byStars);

    // ---- agregado: promedio + conteo + distribución ----
    var total = data && data.reviewCount ? data.reviewCount : reviews.length;
    var avg = data && data.reviewAverageValue ? data.reviewAverageValue : (function(){
      var s = reviews.reduce(function(a,r){ return a + (+r.s||0); }, 0); return reviews.length ? s/reviews.length : 0;
    })();
    var dist = {5:0,4:0,3:0,2:0,1:0};
    if(data && data.stars && data.stars.length){
      data.stars.forEach(function(o){ dist[o.star] = (dist[o.star]||0) + (+o.count||0); });
    } else {
      reviews.forEach(function(r){ var k = Math.round(+r.s||0); if(dist[k]!=null) dist[k]++; });
    }

    function el(tag, cls){ var e = document.createElement(tag); if(cls) e.className = cls; return e; }
    function shorten(t, max){ t = ('' + t).trim(); var dot = t.indexOf('. '); if(dot > 40 && dot < max){ return t.slice(0, dot + 1); } if(t.length <= max){ return t; } return t.slice(0, max).replace(/\s+\S*$/, '') + '…'; }
    function starRow(n, size){
      var box = el('span', 'dor-stars ' + (size||'dor-md'));
      for(var i=1;i<=5;i++){ var s = el('span', i<=n ? 's' : 'e'); s.textContent = '★'; box.appendChild(s); }
      return box;
    }

    // promedio
    var avgEl = root.querySelector('[data-dor-avg]'); if(avgEl) avgEl.textContent = (Math.round(avg*100)/100).toFixed(2);
    var cntEl = root.querySelector('[data-dor-count]'); if(cntEl) cntEl.textContent = total.toLocaleString('es-MX');
    var bigStars = root.querySelector('[data-dor-bigstars]'); if(bigStars) bigStars.appendChild(starRow(Math.round(avg), 'dor-lg'));

    // barras
    var bars = root.querySelector('[data-dor-bars]');
    if(bars){
      [5,4,3,2,1].forEach(function(star){
        var c = dist[star] || 0, pct = total ? (c/total*100) : 0;
        var row = el('div','dor-bar');
        var lbl = el('span','lbl'); lbl.textContent = star; var st = el('span','st'); st.textContent='★'; lbl.appendChild(st);
        var track = el('span','dor-track'); var fill = el('span','dor-fill'); fill.style.width = pct.toFixed(1)+'%'; track.appendChild(fill);
        var cnt = el('span','cnt'); cnt.textContent = c.toLocaleString('es-MX');
        row.appendChild(lbl); row.appendChild(track); row.appendChild(cnt); bars.appendChild(row);
      });
    }

    // resumen: si el merchant no escribió uno, usa el de Revie (recortado)
    var aiBox = root.querySelector('[data-dor-ai]');
    var sumEl = root.querySelector('[data-dor-summary]');
    if(sumEl && !sumEl.textContent.trim() && data && data.summary){
      sumEl.textContent = shorten(data.summary, 180);
    }
    if(aiBox && sumEl && sumEl.textContent.trim()){ aiBox.hidden = false; }
    var tagsBox = root.querySelector('[data-dor-tags]');
    if(tagsBox && data && data.tags && data.tags.length){
      data.tags.slice(0,8).forEach(function(t){ var c = el('span','dor-tag'); c.textContent = t; tagsBox.appendChild(c); });
    }

    // ---- tarjetas ----
    var tpl = root.querySelector('[data-dor-card]');
    var box = root.querySelector('[data-dor-reviews]');
    var emptyEl = root.querySelector('[data-dor-empty]');
    var moreBtn = root.querySelector('[data-dor-more]');
    var viewAll = root.querySelector('[data-dor-viewall]');
    if(!tpl || !box) return;

    function buildCard(r){
      var node = tpl.content.firstElementChild.cloneNode(true);
      var fn = r.n || '';
      var li = r.li || '';
      node.querySelector('.dor-nm').textContent = (fn + (li ? ' ' + li + '.' : '')).trim();
      var d = new Date(r.d);
      node.querySelector('.dor-date').textContent = isNaN(d) ? '' : (d.getDate() + ' ' + MES[d.getMonth()] + ' ' + d.getFullYear());
      var stars = Math.round(+r.s||0);
      node.querySelector('.dor-rev-stars').appendChild(starRow(stars));
      node.querySelector('.dor-text').textContent = r.c;
      var photoWrap = node.querySelector('.dor-photo');
      var src = r.img || null;
      if(src){ var img = photoWrap.querySelector('img'); img.src = src; img.onerror = function(){ photoWrap.hidden = true; }; photoWrap.hidden = false; }
      else { photoWrap.remove(); }
      if(stars >= 5){ node.querySelector('.dor-rec').hidden = false; } else { node.querySelector('.dor-rec').remove(); }
      return node;
    }

    var current = reviews.slice();
    var shown = 0;
    function render(reset){
      if(reset){ box.textContent = ''; shown = 0; }
      var next = current.slice(shown, shown + perPage);
      next.forEach(function(r){ box.appendChild(buildCard(r)); });
      shown += next.length;
      if(emptyEl) emptyEl.hidden = current.length !== 0;
      if(moreBtn) moreBtn.hidden = shown >= current.length;
      if(viewAll) viewAll.hidden = shown < current.length;
    }
    render(true);

    if(moreBtn){ moreBtn.addEventListener('click', function(){ render(false); }); }

    // ---- filtros / orden ----
    var chips = root.querySelector('[data-dor-chips]');
    if(chips){
      // un chip por cada calificación que realmente tenga reseñas (5,4,3,2,1) — transparencia
      var present = {};
      reviews.forEach(function(r){ present[Math.round(+r.s || 0)] = true; });
      var photoChip = chips.querySelector('[data-mode="photo"]');
      [5,4,3,2,1].forEach(function(star){
        if(!present[star]) return;
        var b = el('button','dor-chip'); b.type = 'button'; b.setAttribute('data-mode', String(star));
        b.appendChild(document.createTextNode(star + ' '));
        var st = el('span','dor-st'); st.textContent = '★'; b.appendChild(st);
        if(photoChip){ chips.insertBefore(b, photoChip); } else { chips.appendChild(b); }
      });

      chips.addEventListener('click', function(e){
        var btn = e.target.closest('.dor-chip'); if(!btn) return;
        chips.querySelectorAll('.dor-chip').forEach(function(c){ c.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var mode = btn.getAttribute('data-mode');
        if(mode === 'recent'){ current = reviews.slice().sort(function(a,b){ return ts(b)-ts(a); }); }
        else if(/^[1-5]$/.test(mode)){ var sv = +mode; current = reviews.filter(function(r){ return Math.round(+r.s)===sv; }); }
        else if(mode === 'photo'){ current = reviews.filter(function(r){ return !!r.img; }); }
        else { current = reviews.slice(); }
        render(true);
      });
    }
  }

  // Make the hero rating ("4.7 · +500,000 tazas vendidas") jump to this reviews section.
  // Lives here so it self-removes if the reviews section is ever dropped (no orphaned handler).
  function wireRating(){
    document.querySelectorAll('.dose-hero__rating:not([data-dor-jump])').forEach(function(el){
      el.setAttribute('data-dor-jump','');
      el.style.cursor = 'pointer';
      el.setAttribute('role','link');
      el.setAttribute('tabindex','0');
      el.setAttribute('aria-label','Ver reseñas de clientes');
      function go(){ var r = document.querySelector('.dor'); if(r){ r.scrollIntoView({ behavior:'smooth', block:'start' }); } }
      el.addEventListener('click', go);
      el.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); go(); } });
    });
  }

  function boot(){ document.querySelectorAll('.dor:not([data-dor-ready])').forEach(init); wireRating(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dose-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.dorReady) return;
    root.dataset.dorReady = '1';

    var MES = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 8;

    function parseMeta(sel){
      var el = root.querySelector(sel);
      if(!el) return null;
      var t = (el.textContent || '').trim();
      if(!t) return null;
      try { var v = JSON.parse(t); if(typeof v === 'string'){ v = JSON.parse(v); } return v; }
      catch(e){ return null; }
    }

    var list = parseMeta('[data-dor-list]') || [];
    var data = parseMeta('[data-dor-data]');
    if(!Array.isArray(list) || !list.length) return;

    // solo reseñas con comentario
    var reviews = list.filter(function(r){ return r && r.c && (''+r.c).trim().length > 0; });
    // por defecto: primero 5★, luego 4★, 3★…; dentro de cada grupo, las más recientes
    function ts(r){ var d = new Date(r.d).getTime(); return isNaN(d) ? 0 : d; }
    function byStars(a,b){ return ((+b.s||0) - (+a.s||0)) || (ts(b) - ts(a)); }
    reviews.sort(byStars);

    // ---- agregado: promedio + conteo + distribución ----
    var total = data && data.reviewCount ? data.reviewCount : reviews.length;
    var avg = data && data.reviewAverageValue ? data.reviewAverageValue : (function(){
      var s = reviews.reduce(function(a,r){ return a + (+r.s||0); }, 0); return reviews.length ? s/reviews.length : 0;
    })();
    var dist = {5:0,4:0,3:0,2:0,1:0};
    if(data && data.stars && data.stars.length){
      data.stars.forEach(function(o){ dist[o.star] = (dist[o.star]||0) + (+o.count||0); });
    } else {
      reviews.forEach(function(r){ var k = Math.round(+r.s||0); if(dist[k]!=null) dist[k]++; });
    }

    function el(tag, cls){ var e = document.createElement(tag); if(cls) e.className = cls; return e; }
    function shorten(t, max){ t = ('' + t).trim(); var dot = t.indexOf('. '); if(dot > 40 && dot < max){ return t.slice(0, dot + 1); } if(t.length <= max){ return t; } return t.slice(0, max).replace(/\s+\S*$/, '') + '…'; }
    function starRow(n, size){
      var box = el('span', 'dor-stars ' + (size||'dor-md'));
      for(var i=1;i<=5;i++){ var s = el('span', i<=n ? 's' : 'e'); s.textContent = '★'; box.appendChild(s); }
      return box;
    }

    // promedio
    var avgEl = root.querySelector('[data-dor-avg]'); if(avgEl) avgEl.textContent = (Math.round(avg*100)/100).toFixed(2);
    var cntEl = root.querySelector('[data-dor-count]'); if(cntEl) cntEl.textContent = total.toLocaleString('es-MX');
    var bigStars = root.querySelector('[data-dor-bigstars]'); if(bigStars) bigStars.appendChild(starRow(Math.round(avg), 'dor-lg'));

    // barras
    var bars = root.querySelector('[data-dor-bars]');
    if(bars){
      [5,4,3,2,1].forEach(function(star){
        var c = dist[star] || 0, pct = total ? (c/total*100) : 0;
        var row = el('div','dor-bar');
        var lbl = el('span','lbl'); lbl.textContent = star; var st = el('span','st'); st.textContent='★'; lbl.appendChild(st);
        var track = el('span','dor-track'); var fill = el('span','dor-fill'); fill.style.width = pct.toFixed(1)+'%'; track.appendChild(fill);
        var cnt = el('span','cnt'); cnt.textContent = c.toLocaleString('es-MX');
        row.appendChild(lbl); row.appendChild(track); row.appendChild(cnt); bars.appendChild(row);
      });
    }

    // resumen: si el merchant no escribió uno, usa el de Revie (recortado)
    var aiBox = root.querySelector('[data-dor-ai]');
    var sumEl = root.querySelector('[data-dor-summary]');
    if(sumEl && !sumEl.textContent.trim() && data && data.summary){
      sumEl.textContent = shorten(data.summary, 180);
    }
    if(aiBox && sumEl && sumEl.textContent.trim()){ aiBox.hidden = false; }
    var tagsBox = root.querySelector('[data-dor-tags]');
    if(tagsBox && data && data.tags && data.tags.length){
      data.tags.slice(0,8).forEach(function(t){ var c = el('span','dor-tag'); c.textContent = t; tagsBox.appendChild(c); });
    }

    // ---- tarjetas ----
    var tpl = root.querySelector('[data-dor-card]');
    var box = root.querySelector('[data-dor-reviews]');
    var emptyEl = root.querySelector('[data-dor-empty]');
    var moreBtn = root.querySelector('[data-dor-more]');
    var viewAll = root.querySelector('[data-dor-viewall]');
    if(!tpl || !box) return;

    function buildCard(r){
      var node = tpl.content.firstElementChild.cloneNode(true);
      var fn = r.n || '';
      var li = r.li || '';
      node.querySelector('.dor-nm').textContent = (fn + (li ? ' ' + li + '.' : '')).trim();
      var d = new Date(r.d);
      node.querySelector('.dor-date').textContent = isNaN(d) ? '' : (d.getDate() + ' ' + MES[d.getMonth()] + ' ' + d.getFullYear());
      var stars = Math.round(+r.s||0);
      node.querySelector('.dor-rev-stars').appendChild(starRow(stars));
      node.querySelector('.dor-text').textContent = r.c;
      var photoWrap = node.querySelector('.dor-photo');
      var src = r.img || null;
      if(src){ var img = photoWrap.querySelector('img'); img.src = src; img.onerror = function(){ photoWrap.hidden = true; }; photoWrap.hidden = false; }
      else { photoWrap.remove(); }
      if(stars >= 5){ node.querySelector('.dor-rec').hidden = false; } else { node.querySelector('.dor-rec').remove(); }
      return node;
    }

    var current = reviews.slice();
    var shown = 0;
    function render(reset){
      if(reset){ box.textContent = ''; shown = 0; }
      var next = current.slice(shown, shown + perPage);
      next.forEach(function(r){ box.appendChild(buildCard(r)); });
      shown += next.length;
      if(emptyEl) emptyEl.hidden = current.length !== 0;
      if(moreBtn) moreBtn.hidden = shown >= current.length;
      if(viewAll) viewAll.hidden = shown < current.length;
    }
    render(true);

    if(moreBtn){ moreBtn.addEventListener('click', function(){ render(false); }); }

    // ---- filtros / orden ----
    var chips = root.querySelector('[data-dor-chips]');
    if(chips){
      // un chip por cada calificación que realmente tenga reseñas (5,4,3,2,1) — transparencia
      var present = {};
      reviews.forEach(function(r){ present[Math.round(+r.s || 0)] = true; });
      var photoChip = chips.querySelector('[data-mode="photo"]');
      [5,4,3,2,1].forEach(function(star){
        if(!present[star]) return;
        var b = el('button','dor-chip'); b.type = 'button'; b.setAttribute('data-mode', String(star));
        b.appendChild(document.createTextNode(star + ' '));
        var st = el('span','dor-st'); st.textContent = '★'; b.appendChild(st);
        if(photoChip){ chips.insertBefore(b, photoChip); } else { chips.appendChild(b); }
      });

      chips.addEventListener('click', function(e){
        var btn = e.target.closest('.dor-chip'); if(!btn) return;
        chips.querySelectorAll('.dor-chip').forEach(function(c){ c.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var mode = btn.getAttribute('data-mode');
        if(mode === 'recent'){ current = reviews.slice().sort(function(a,b){ return ts(b)-ts(a); }); }
        else if(/^[1-5]$/.test(mode)){ var sv = +mode; current = reviews.filter(function(r){ return Math.round(+r.s)===sv; }); }
        else if(mode === 'photo'){ current = reviews.filter(function(r){ return !!r.img; }); }
        else { current = reviews.slice(); }
        render(true);
      });
    }
  }

  // Make the hero rating ("4.7 · +500,000 tazas vendidas") jump to this reviews section.
  // Lives here so it self-removes if the reviews section is ever dropped (no orphaned handler).
  function wireRating(){
    document.querySelectorAll('.dose-hero__rating:not([data-dor-jump])').forEach(function(el){
      el.setAttribute('data-dor-jump','');
      el.style.cursor = 'pointer';
      el.setAttribute('role','link');
      el.setAttribute('tabindex','0');
      el.setAttribute('aria-label','Ver reseñas de clientes');
      function go(){ var r = document.querySelector('.dor'); if(r){ r.scrollIntoView({ behavior:'smooth', block:'start' }); } }
      el.addEventListener('click', go);
      el.addEventListener('keydown', function(e){ if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); go(); } });
    });
  }

  function boot(){ document.querySelectorAll('.dor:not([data-dor-ready])').forEach(init); wireRating(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dose-sub-benefits-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mo = null, deb = 0;
    function $(s, r) { return (r || document).querySelector(s); }
    function num(s) { if (s == null) return null; var n = parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')); return isNaN(n) ? null : n; }
    function moneyInt(n) { return '$' + n.toLocaleString('es-MX'); }
    function perTxt(price, porc, label) { return '$' + (price / porc).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (label || '/ porción'); }
    function cfg() { var e = $('[data-dose-subs-config]'); if (!e) return null; try { return JSON.parse(e.textContent); } catch (x) { return null; } }
    function porcSel() { var b = $('.kaching-bundles__bar--selected'); if (!b) return null; var m = b.textContent.match(/(\d{2,4})\s*porcion/i) || b.textContent.match(/(\d{2,4})/); return m ? parseInt(m[1], 10) : null; }
    function freqTxt() { var e = $('.kaching-subscriptions__dropdown-trigger-label'); return e ? e.textContent.trim() : ''; }
    function childByClass(parent, cls) { return parent ? parent.querySelector(':scope > .' + cls) : null; }
    function mk(tag, cls) { var el = document.createElement(tag); el.className = cls; return el; }

    // Keep a quantity tile sticky: Kaching deselects the tile when you re-click the already-selected
    // bar (→ nothing selected, buy box silently falls back to base 30 porciones). Block just that one
    // interaction in the capture phase so a selected tile stays selected; clicking a DIFFERENT tile is
    // untouched (that bar isn't --selected, so the event passes straight through to Kaching).
    document.addEventListener('click', function (e) {
      var bar = e.target && e.target.closest ? e.target.closest('.kaching-bundles__bar') : null;
      if (bar && bar.classList.contains('kaching-bundles__bar--selected')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);

    function render() {
      var c = cfg(); if (!c) return;
      var sub = $('.kaching-subscriptions__with-explanation');
      var src = $('[data-dose-subs]');
      if (!sub || !src) return;
      var porc = porcSel();

      if (mo) mo.disconnect();
      try {
        // Ribbon
        if (c.ribbon && c.ribbon.show && c.ribbon.text) sub.setAttribute('data-dose-ribbon', c.ribbon.text);
        else sub.removeAttribute('data-dose-ribbon');

        var priceWrap = $('.ks-price-wrapper', sub);

        // Discount corner badge on the subscribe card ("Ahorra X%", where "Mejor Valor" sat), from
        // Kaching's label. Strip the old inline pill if a prior render added one.
        var label = $('.ks-discount-label', sub);
        var oldPill = childByClass(priceWrap, 'dose-pill');
        if (oldPill) oldPill.remove();
        var m = label ? label.textContent.match(/ahorra\s*\d+\s*%/i) : null;
        if (m) sub.setAttribute('data-dose-disc', m[0].replace(/\s+/g, ' '));
        else sub.removeAttribute('data-dose-disc');

        // $/porción (subscribe)
        if (c.showPerServing && porc && priceWrap) {
          var subNow = num(($('.ks-discounted-price', sub) || {}).textContent);
          if (subNow) {
            var ps = childByClass(priceWrap, 'dose-perserving');
            if (!ps) { ps = mk('div', 'dose-perserving'); priceWrap.appendChild(ps); }
            ps.textContent = perTxt(subNow, porc, c.perServingLabel);
          }
        }

        // Ship line (full-width, after .ks-card-info)
        var card = $('.ks-card', sub), info = $('.ks-card-info', sub);
        if (card && info && porc) {
          var ship = childByClass(card, 'dose-ship-line');
          if (!ship) { ship = src.querySelector('.dose-ship-line').cloneNode(true); info.insertAdjacentElement('afterend', ship); }
          var txt = (c.shipTemplate || '{porciones} porciones enviadas cada {frecuencia}').replace('{porciones}', porc).replace('{frecuencia}', freqTxt());
          ship.querySelector('[data-dose-ship-text]').textContent = txt;
        }

        // Beneficios box (single section-level list, cloned once before the frequency control)
        var fw = $('.ks-features-wrapper', sub);
        if (fw) {
          var active = src.querySelector('.dose-benefits');
          var cur = childByClass(fw, 'dose-benefits');
          if (active && !cur) {
            var clone = active.cloneNode(true);
            var freq = $('.ks-delivery-frequency-wrapper', fw);
            if (freq) fw.insertBefore(clone, freq); else fw.appendChild(clone);
          }
        }

        // One-time: strikethrough + $/porción
        var otWrap = $('.one-time-purchase .kaching-subscriptions__card-price-wrapper');
        if (otWrap) {
          var otNow = num(($('.one-time-purchase .kaching-subscriptions__card-price') || {}).textContent);
          var orig = num(($('.ks-original-price', sub) || {}).textContent);
          var was = childByClass(otWrap, 'dose-ot-was');
          if (orig && otNow && orig > otNow) {
            if (!was) { was = mk('span', 'dose-ot-was'); otWrap.insertBefore(was, otWrap.firstChild); }
            was.textContent = moneyInt(orig);
          } else if (was) { was.remove(); }
          // One-time discount corner badge = (orig − now)/orig; hidden when there's no discount
          var otCard = $('.one-time-purchase');
          if (otCard) {
            if (orig && otNow && orig > otNow) otCard.setAttribute('data-dose-disc', 'Ahorra ' + Math.round((orig - otNow) / orig * 100) + '%');
            else otCard.removeAttribute('data-dose-disc');
          }
          if (c.showPerServing && otNow && porc) {
            var ops = childByClass(otWrap, 'dose-perserving');
            if (!ops) { ops = mk('div', 'dose-perserving'); otWrap.appendChild(ops); }
            ops.textContent = perTxt(otNow, porc, c.perServingLabel);
          }
        }

        // Tile pills + tile-price hide are now PURE CSS (the kaching-bundles-block rules in the
        // stylesheet) — they paint correct on Kaching's first frame with no JS. Nothing to do here.
      } finally {
        observe();
      }
    }

    function observe() {
      var w = $('.kaching-subscriptions__cards-wrapper') || $('kaching-subscriptions-block');
      if (!w) return;
      mo = new MutationObserver(function () { if (deb) return; deb = requestAnimationFrame(function () { deb = 0; render(); }); });
      mo.observe(w, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      var b = $('.kaching-bundles');
      if (b) mo.observe(b, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if ($('.kaching-subscriptions__cards-wrapper')) { clearInterval(iv); render(); }
      else if (tries > 80) clearInterval(iv);
    }, 250);
  })();

  /* ===== Quantity-tile badges ("Más Vendido" / "Mejor Valor") =====
     Adds a top-center badge to the tile whose porciones matches a configured badge. Self-contained and
     independent of the subscribe card, so it also paints on products that have quantity tiles but no
     subscription option. Matches by porciones (robust to tile order/count); text + color come from the
     section settings JSON. Observes class/childList only (not attributes), so setting the badge's inline
     color never re-triggers it — no loop. */
  (function () {
    var cfgEl = document.querySelector('[data-dose-subs-config]');
    if (!cfgEl) return;
    var badges = [];
    try { badges = (JSON.parse(cfgEl.textContent).badges || []).filter(function (b) { return b && b.text && b.porciones; }); }
    catch (e) { return; }
    var deb = 0;
    function num(s) { if (s == null) return null; var n = parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')); return isNaN(n) ? null : n; }
    function porcOf(bar) { var m = bar.textContent.match(/(\d{2,4})\s*porcion/i) || bar.textContent.match(/(\d{2,4})/); return m ? parseInt(m[1], 10) : null; }
    function paint() {
      document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        // "Más Vendido" / "Mejor Valor" badge (top-center)
        var p = porcOf(bar), hit = null;
        badges.forEach(function (b) { if (parseInt(b.porciones, 10) === p) hit = b; });
        var el = bar.querySelector(':scope > .dose-tile-badge');
        if (hit) {
          if (!el) { el = document.createElement('span'); el.className = 'dose-tile-badge'; bar.appendChild(el); }
          if (el.textContent !== hit.text) el.textContent = hit.text;
          if (hit.color) el.style.background = hit.color;
        } else if (el) { el.remove(); }

        // "Ahorra $X" peso pill = full-price − now-price. No discount (now == full) → hide the crossed
        // price (don't strike the same number) and drop the pill. So 30 porciones shows one clean price.
        var pricing = bar.querySelector('.kaching-bundles__bar-pricing');
        if (pricing) {
          var nowEl = pricing.querySelector('.kaching-bundles__bar-price');
          var fullEl = pricing.querySelector('.kaching-bundles__bar-full-price');
          var now = num(nowEl && nowEl.textContent), full = num(fullEl && fullEl.textContent);
          var ah = pricing.querySelector(':scope > .dose-tile-ahorra');
          if (now != null && full != null && full > now) {
            if (fullEl) fullEl.style.display = '';
            var txt = 'Ahorra $' + Math.round(full - now).toLocaleString('es-MX');
            if (!ah) { ah = document.createElement('span'); ah.className = 'dose-tile-ahorra'; pricing.appendChild(ah); }
            if (ah.textContent !== txt) ah.textContent = txt;
          } else {
            if (fullEl) fullEl.style.display = 'none';
            if (ah) ah.remove();
          }
        }
      });
    }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (document.querySelector('.kaching-bundles__bar')) { clearInterval(iv); paint(); }
      else if (tries > 80) clearInterval(iv);
    }, 250);
    var root = document.querySelector('.kaching-bundles') || document.body;
    var mo = new MutationObserver(function () { if (deb) return; deb = requestAnimationFrame(function () { deb = 0; paint(); }); });
    mo.observe(root, { subtree: true, childList: true, characterData: true });
  })();

  /* ===== Mundial promo widget =====
     Inserts the widget directly BELOW the "Agregar al carrito" button (afterend of
     .product__submit__buttons — a stable theme class, not Kaching-dependent) and keeps its price
     math live off Kaching's own rendered one-time price: promo = one-time price × (1 − pct/100).
     Hides the deal when the subscription card is selected (code is one-time-only at checkout).
     The copy control is type="button" so it never submits the surrounding product form.
     Self-contained; if the template is absent (setting off) or the anchor never renders, nothing
     happens. Fallback anchor: above the quantity tiles, so the promo still shows if the theme
     button class ever changes. */
  (function () {
    var tpl = document.querySelector('[data-dose-mundial-tpl]');
    if (!tpl || !('content' in tpl)) return;
    var widget = null, deb = 0;

    function num(s) { if (s == null) return null; var n = parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')); return isNaN(n) ? null : n; }
    function money(n) { return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: (n % 1 ? 2 : 0), maximumFractionDigits: 2 }); }

    function place() {
      if (widget) return true;
      var btn = document.querySelector('.product__submit__buttons');
      var anchor = btn || document.querySelector('kaching-bundles-block');
      if (!anchor) return false;
      widget = tpl.content.firstElementChild.cloneNode(true);
      anchor.insertAdjacentElement(btn ? 'afterend' : 'beforebegin', widget);
      wireCopy();
      return true;
    }

    function oneTimeSelected() {
      var ot = document.querySelector('.kaching-subscriptions__card-wrapper.one-time-purchase');
      if (!ot) return true; /* sub cards not rendered (or product has none) -> treat as one-time */
      return ot.classList.contains('selected');
    }

    function currentPrice() {
      /* primary: Kaching's one-time card price (already tier-discounted) */
      var el = document.querySelector('.one-time-purchase .kaching-subscriptions__card-price');
      var n = el ? num(el.textContent) : null;
      if (n) return n;
      /* fallback: selected tile's own (CSS-hidden) pricing text — first $ amount is the current price */
      var bar = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-pricing');
      if (bar) { var m = bar.textContent.match(/\$\s*[\d.,]+/); if (m) return num(m[0]); }
      return null;
    }

    function update() {
      if (!place()) return;
      var sub = !oneTimeSelected();
      widget.classList.toggle('dose-mundial--sub', sub);
      if (sub) return;
      var pct = parseFloat(widget.getAttribute('data-pct')) || 15;
      var p = currentPrice();
      if (!p) { widget.classList.remove('dose-mundial--priced'); return; }
      var promo = Math.round(p * (100 - pct)) / 100;
      widget.querySelector('[data-mundial-was]').textContent = money(p);
      widget.querySelector('[data-mundial-now]').textContent = money(promo);
      widget.classList.add('dose-mundial--priced');
    }

    function wireCopy() {
      var btn = widget.querySelector('[data-mundial-copy]');
      var hint = widget.querySelector('[data-mundial-hint]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = widget.getAttribute('data-code') || '';
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code);
        btn.classList.add('is-copied');
        if (hint) hint.textContent = hint.getAttribute('data-copied') || hint.textContent;
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (hint) hint.textContent = hint.getAttribute('data-hint') || '';
        }, 2200);
      });
    }

    /* poll until placed+priced (Kaching renders client-side), then mutations keep it live */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      update();
      if ((widget && widget.classList.contains('dose-mundial--priced')) || tries > 120) clearInterval(iv);
    }, 250);
    var mo = new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(update, 200); });
    mo.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  })();

  /* ===== Sticky add-to-cart (DOSE custom, IM8-style drop-up) =====
     Mirrors the buy box: porciones tile + compra única/suscripción + price.
     Reads everything live from the Kaching widget, so it works on every product.
     The real "Agregar al carrito" button does the actual add (respects the selected format). */
  (function () {
    if (window.__doseSatc) return; window.__doseSatc = true;

    var CSS = [
      '.dsatc{position:fixed;left:0;right:0;bottom:0;z-index:9990;transform:translateY(130%);transition:transform .28s cubic-bezier(.2,.8,.2,1);pointer-events:none;background:rgba(255,255,255,.975);-webkit-backdrop-filter:saturate(140%) blur(8px);backdrop-filter:saturate(140%) blur(8px);border-top:1px solid #ece7e0;box-shadow:0 -10px 34px rgba(20,15,10,.10)}',
      '.dsatc.on{transform:translateY(0);pointer-events:auto}',
      '.dsatc__bar{max-width:520px;margin:0 auto;padding:10px 14px calc(10px + env(safe-area-inset-bottom));display:flex;gap:9px;align-items:stretch}',
      '.dsatc__pill{flex:1 1 auto;min-width:0;text-align:left;background:#fff;border:1.6px solid #e7ddd3;border-radius:15px;padding:7px 12px;display:flex;align-items:center;gap:10px;cursor:pointer;font-family:inherit;color:#1a1513}',
      '.dsatc__pill.open{border-color:#e11414;box-shadow:0 0 0 3px rgba(225,20,20,.10)}',
      '.dsatc__tx{flex:1;min-width:0;display:flex;flex-direction:column}',
      '.dsatc__l1{font-weight:700;font-size:14.5px;line-height:1.15;display:flex;align-items:center;gap:7px}',
      '.dsatc__tag{font-size:9.5px;font-weight:800;letter-spacing:.3px;color:#fff;background:#6d3bd6;padding:2px 7px;border-radius:99px;text-transform:uppercase;white-space:nowrap}',
      '.dsatc__l2{font-size:12px;color:#7a7269;margin-top:1px;font-weight:600}',
      '.dsatc__l2 b{color:#1a1513;font-weight:700}.dsatc__l2 .d{color:#1a8f4a;font-weight:700}',
      '.dsatc__car{flex:none;font-size:12px;color:#e11414;transition:transform .22s;line-height:1}',
      '.dsatc__pill.open .dsatc__car{transform:rotate(180deg)}',
      '.dsatc__add{flex:0 0 auto;background:#ED2232;color:#fff;border:none;border-radius:300px;font-family:inherit;font-weight:700;font-size:15px;letter-spacing:.3px;padding:0 24px;cursor:pointer;white-space:nowrap;transition:transform .08s}',
      '.dsatc__add:active{transform:scale(.97)}',
      '.dsatc__menu{position:fixed;left:50%;transform:translateX(-50%) translateY(12px);width:calc(100% - 24px);max-width:496px;bottom:70px;background:#fff;border:1px solid #efe7dd;border-radius:18px;box-shadow:0 18px 50px rgba(20,15,10,.22);overflow:hidden;z-index:9991;opacity:0;visibility:hidden;pointer-events:none;transition:opacity .2s,transform .22s cubic-bezier(.2,.8,.2,1)}',
      '.dsatc__menu.on{opacity:1;visibility:visible;pointer-events:auto;transform:translateX(-50%) translateY(0)}',
      '.dsatc__hd{font-size:11px;letter-spacing:1.3px;font-weight:700;color:#7a7269;padding:13px 16px 7px;text-transform:uppercase;display:flex;justify-content:space-between}',
      '.dsatc__hd .f{color:#6d3bd6;font-weight:800}',
      '.dsatc__opt{display:flex;align-items:center;gap:12px;padding:12px 16px;cursor:pointer;border-top:1px solid #f3ece3}',
      '.dsatc__opt:hover{background:#faf6f0}',
      '.dsatc__rd{flex:none;width:20px;height:20px;border-radius:50%;border:2px solid #d7cabb;display:grid;place-items:center}',
      '.dsatc__opt.sel .dsatc__rd{border-color:#e11414;background:#e11414}',
      '.dsatc__ck{color:#fff;font-size:12px;font-weight:900;opacity:0;line-height:1}.dsatc__opt.sel .dsatc__ck{opacity:1}',
      '.dsatc__om{flex:1;min-width:0;display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}',
      '.dsatc__ot{font-weight:700;font-size:15px}',
      '.dsatc__od{font-size:12px;font-weight:700;color:#1a8f4a}.dsatc__od.none{color:#7a7269;font-weight:600}',
      '.dsatc__op{text-align:right;flex:none}',
      '.dsatc__on{font-weight:800;font-size:15.5px;color:#e11414}',
      '.dsatc__ow{font-size:11.5px;color:#a89c8d;text-decoration:line-through;font-weight:600}',
      '.dsatc__scrim{position:fixed;inset:0;background:rgba(20,15,10,.18);opacity:0;visibility:hidden;transition:opacity .2s;z-index:9989}',
      '.dsatc__scrim.on{opacity:1;visibility:visible}'
    ].join('');
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

    function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
    function money(n) { return '$' + Math.round(n).toLocaleString('es-MX'); }
    function toNum(s) { return parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')) || 0; }
    function pct(now, was) { return was > 0 ? Math.round((1 - now / was) * 100) : 0; }

    var scrim = el('div', 'dsatc__scrim');
    var menu = el('div', 'dsatc__menu');
    var hd = el('div', 'dsatc__hd'); hd.appendChild(el('span', null, 'Elige la cantidad')); var hdF = el('span', 'f'); hd.appendChild(hdF); menu.appendChild(hd);
    var optBox = el('div'); menu.appendChild(optBox);
    var root = el('div', 'dsatc'); var bar = el('div', 'dsatc__bar');
    var pill = el('button', 'dsatc__pill'); pill.type = 'button';
    var tx = el('span', 'dsatc__tx'); var l1 = el('span', 'dsatc__l1'); var l2 = el('span', 'dsatc__l2'); tx.appendChild(l1); tx.appendChild(l2);
    pill.appendChild(tx); pill.appendChild(el('span', 'dsatc__car', '▼'));
    var add = el('button', 'dsatc__add', 'AGREGAR'); add.type = 'button';
    bar.appendChild(pill); bar.appendChild(add); root.appendChild(bar);
    document.body.appendChild(scrim); document.body.appendChild(menu); document.body.appendChild(root);

    function findAtc() {
      var bs = [].slice.call(document.querySelectorAll('button, input[type="submit"], [role="button"]')), hit = null;
      for (var i = 0; i < bs.length; i++) { var t = (bs[i].textContent || bs[i].value || ''); if (/agregar al carrito/i.test(t)) { if (bs[i].offsetParent !== null) return bs[i]; if (!hit) hit = bs[i]; } }
      return hit;
    }
    function subSelected() {
      var ot = document.querySelector('.kaching-subscriptions__card-wrapper.one-time-purchase');
      return ot ? !ot.classList.contains('selected') : false;
    }
    function readTiers() {
      var out = [];
      [].slice.call(document.querySelectorAll('.kaching-bundles__bar')).forEach(function (b) {
        var txt = (b.textContent || '').replace(/\s+/g, ' ').trim();
        var pm = txt.match(/(\d{2,4})\s*porcion/i) || txt.match(/(\d{2,4})/); if (!pm) return;
        var pxt = txt.replace(/ahorra\s*\$\s*[\d.,]+/ig, ' '); /* strip "Ahorra $X" (savings) so it isn't parsed as the price */
        var ps = (pxt.match(/\$\s*[\d.,]+/g) || []).map(toNum).filter(function (n) { return n > 0; });
        out.push({ porc: parseInt(pm[1], 10), now: ps.length ? Math.min.apply(null, ps) : 0, was: ps.length > 1 ? Math.max.apply(null, ps) : null, bar: b, sel: b.classList.contains('kaching-bundles__bar--selected') });
      });
      return out;
    }
    function subFactor(tiers, sel) {
      var sc = document.querySelector('.kaching-subscriptions__with-explanation'); if (!sc || sel < 0) return null;
      var ps = (sc.textContent.match(/\$\s*[\d.,]+/g) || []).map(toNum).filter(function (n) { return n > 0; });
      if (!ps.length || !tiers[sel] || !tiers[sel].now) return null;
      return Math.min.apply(null, ps) / tiers[sel].now;
    }

    var S = { tiers: [], sel: 0, sub: false };
    function compute() {
      var tiers = readTiers(), sel = 0; tiers.forEach(function (t, i) { if (t.sel) sel = i; });
      var sub = subSelected(), f = sub ? subFactor(tiers, sel) : null, showSub = !!(sub && f);
      tiers.forEach(function (t) {
        var reg = t.was || t.now;
        if (showSub) { t.dn = t.now * f; t.dw = reg; t.off = pct(t.dn, reg); }
        else { t.dn = t.now; t.dw = t.was; t.off = t.was ? pct(t.now, t.was) : 0; }
      });
      S.tiers = tiers; S.sel = sel; S.sub = showSub;
    }
    function renderPill() {
      var t = S.tiers[S.sel]; if (!t) return;
      l1.textContent = ''; l1.appendChild(document.createTextNode(t.porc + ' Porciones'));
      if (S.sub) l1.appendChild(el('span', 'dsatc__tag', 'Suscripción'));
      l2.textContent = ''; l2.appendChild(el('b', null, money(t.dn)));
      if (t.off > 0) { l2.appendChild(document.createTextNode(' · ')); l2.appendChild(el('span', 'd', 'Ahorra ' + t.off + '%')); }
    }
    function renderMenu() {
      hdF.textContent = S.sub ? 'Suscripción' : '';
      optBox.textContent = '';
      S.tiers.forEach(function (t, i) {
        var row = el('div', 'dsatc__opt' + (i === S.sel ? ' sel' : ''));
        var rd = el('span', 'dsatc__rd'); rd.appendChild(el('span', 'dsatc__ck', '✓')); row.appendChild(rd);
        var om = el('span', 'dsatc__om'); om.appendChild(el('span', 'dsatc__ot', t.porc + ' Porciones'));
        om.appendChild(el('span', 'dsatc__od' + (t.off > 0 ? '' : ' none'), t.off > 0 ? ('Ahorra ' + t.off + '%') : 'Precio regular'));
        row.appendChild(om);
        var op = el('span', 'dsatc__op'); op.appendChild(el('div', 'dsatc__on', money(t.dn)));
        if (t.dw) op.appendChild(el('div', 'dsatc__ow', money(t.dw)));
        row.appendChild(op);
        row.onclick = function () { pick(i); };
        optBox.appendChild(row);
      });
    }
    function refresh() { compute(); renderPill(); if (isOpen()) renderMenu(); }
    function isOpen() { return menu.classList.contains('on'); }
    function openMenu() { renderMenu(); menu.classList.add('on'); scrim.classList.add('on'); pill.classList.add('open'); }
    function closeMenu() { menu.classList.remove('on'); scrim.classList.remove('on'); pill.classList.remove('open'); }
    function pick(i) {
      var t = S.tiers[i];
      if (t && t.bar && !t.bar.classList.contains('kaching-bundles__bar--selected')) {
        (t.bar.querySelector('.kaching-bundles__bar-main') || t.bar.querySelector('label') || t.bar).click();
      }
      closeMenu(); setTimeout(refresh, 280);
    }

    pill.addEventListener('click', function () { isOpen() ? closeMenu() : (refresh(), openMenu()); });
    scrim.addEventListener('click', closeMenu);
    add.addEventListener('click', function () { var a = findAtc(); if (a) { closeMenu(); a.click(); } });

    function wireShow() {
      var atc = findAtc(); if (!atc) return false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { var past = !e.isIntersecting && e.boundingClientRect.top < 0; root.classList.toggle('on', past); if (!past) closeMenu(); });
      }, { threshold: 0 }).observe(atc);
      return true;
    }
    function wireSync() {
      var deb, mo = new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(refresh, 220); });
      var a = document.querySelector('.kaching-bundles'); if (a) mo.observe(a, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true, characterData: true });
      var b = document.querySelector('.kaching-subscriptions__cards-wrapper'); if (b) mo.observe(b, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var tries = 0, iv = setInterval(function () {
      tries++;
      if (document.querySelector('.kaching-bundles__bar') && findAtc()) { clearInterval(iv); compute(); renderPill(); wireShow(); wireSync(); }
      else if (tries > 100) clearInterval(iv);
    }, 200);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scratch-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(){
    var root=document.getElementById('dose-scratch-root');
    if(!root || root.dataset.dsInited) return;
    root.dataset.dsInited='1';

    var inEditor = window.Shopify && window.Shopify.designMode;
    var cfg={
      key:root.dataset.klaviyoKey, list:root.dataset.klaviyoList, code:root.dataset.code,
      useUrl:root.dataset.useUrl||'/collections/all',
      test: root.dataset.testMode==='true',
      trigger: root.dataset.trigger||'exit_delay',
      delay:(parseFloat(root.dataset.delay)||8)*1000,
      scroll:parseFloat(root.dataset.scroll)||40,
      freq:parseFloat(root.dataset.freqDays)||7,
      threshold:(parseFloat(root.dataset.threshold)||55)/100,
      mobile: root.dataset.mobile==='true',
      foil1:root.dataset.foil1||'#EC8FC0', foil2:root.dataset.foil2||'#8A5CD0'
    };
    var isMobile=window.matchMedia('(max-width:600px)').matches;

    var $=function(id){return document.getElementById(id);};
    var stage=$('ds-stage'), emailEl=$('ds-email'), emailBlock=$('ds-emailBlock'), hint=$('ds-hint'),
        actions=$('ds-actions'), a11y=$('ds-a11yReveal'), sub=$('ds-sub'), h1=$('ds-h1'), confetti=$('ds-confetti'),
        hpEl=$('ds-hp');

    var forcePreview=/[?&]dspopup/.test(location.search);

    /* ---- funnel tracking (Klaviyo onsite + Clarity, feature-detected, safe if absent) ---- */
    function track(name, stage, props){
      props=props||{};
      var snake=name.replace(/\s+/g,'_').toLowerCase();
      // GA4 — reliable anonymous view counting (the trustworthy denominator for CVR)
      try{ if(window.gtag) window.gtag('event', snake, props); }catch(e){}
      try{ if(window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({event:snake}, props)); }catch(e){}
      try{ if(window.klaviyo && window.klaviyo.push) window.klaviyo.push(['track', name, props]); }catch(e){}
      try{ if(window._learnq && window._learnq.push) window._learnq.push(['track', name, props]); }catch(e){}
      try{ if(window.clarity){ window.clarity('event', snake); if(stage) window.clarity('set','scratch_stage',stage); } }catch(e){}
    }
    function identifyEmail(email){
      try{ if(window.klaviyo && window.klaviyo.push) window.klaviyo.push(['identify', {'$email': email}]); }catch(e){}
      try{ if(window._learnq && window._learnq.push) window._learnq.push(['identify', {'$email': email}]); }catch(e){}
    }

    /* ---- show / suppress ---- */
    var shown=false;
    function lockScroll(on){ var v=on?'hidden':''; document.documentElement.style.overflow=v; document.body.style.overflow=v; }
    function suppress(){ try{ localStorage.setItem('dose_scratch_until', Date.now()+cfg.freq*864e5);}catch(e){} }
    function canShow(){
      if(inEditor || forcePreview) return true;
      if(isMobile && !cfg.mobile) return false;
      var p=location.pathname; if(p.indexOf('checkout')>-1 || p.indexOf('/challenge')>-1) return false;
      try{ var u=localStorage.getItem('dose_scratch_until'); if(u && Date.now()<+u) return false; }catch(e){}
      try{ if(localStorage.getItem('dose_scratch_done')==='1') return false; }catch(e){}
      return true;
    }
    function show(){ if(shown)return; shown=true; root.hidden=false; lockScroll(true); requestAnimationFrame(function(){root.classList.add('ds-show');}); initScratch(); track('Scratch Popup Shown','shown'); }
    function close(){ track('Scratch Popup Dismissed','dismissed'); root.classList.remove('ds-show'); lockScroll(false); suppress(); setTimeout(function(){root.hidden=true;},350); }

    // close only via the X or the "No gracias" link — no backdrop / Escape dismiss
    $('ds-close').addEventListener('click', close);
    $('ds-nothanks').addEventListener('click', close);

    /* ---- triggers ---- */
    if(inEditor || forcePreview){ show(); }
    else if(canShow()){
      if(cfg.trigger==='delay' || cfg.trigger==='exit_delay'){ setTimeout(function(){ if(canShow()) show(); }, cfg.delay); }
      if((cfg.trigger==='exit' || cfg.trigger==='exit_delay') && !isMobile){
        document.addEventListener('mouseout', function(e){ if(e.clientY<=0 && canShow()) show(); });
      }
      if(cfg.trigger==='scroll'){
        var onScr=function(){ var max=document.body.scrollHeight-window.innerHeight;
          var pct=max>0?(window.scrollY/max)*100:0;
          if(pct>=cfg.scroll && canShow()){ show(); window.removeEventListener('scroll',onScr); } };
        window.addEventListener('scroll', onScr, {passive:true});
      }
    }

    /* ---- Klaviyo subscribe (client-side) ---- */
    function subscribe(email){
      if(cfg.test || !cfg.key || !cfg.list){ if(window.console) console.log('[scratch] test mode — would subscribe:', email); return; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+encodeURIComponent(cfg.key),{
        method:'POST', headers:{'Content-Type':'application/json','revision':'2024-10-15'},
        body:JSON.stringify({data:{type:'subscription',attributes:{
          profile:{data:{type:'profile',attributes:{email:email}}}},
          relationships:{list:{data:{type:'list',id:cfg.list}}}}})
      }).catch(function(e){ if(window.console) console.warn(e); });
    }

    /* ---- STEP 1: email unlocks the card ---- */
    function validEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
    function doUnlock(){
      if(hpEl && hpEl.value){ return; } // honeypot filled → bot, ignore silently
      var v=(emailEl.value||'').trim();
      if(!validEmail(v)){ emailEl.classList.add('ds-err'); emailEl.focus(); return; }
      emailEl.classList.remove('ds-err');
      subscribe(v);
      identifyEmail(v); track('Scratch Popup Email Submitted','email');
      emailBlock.classList.add('ds-collapsed');
      stage.classList.remove('ds-locked');
      if(h1 && root.dataset.headingScratch) h1.textContent=root.dataset.headingScratch;
      if(sub) sub.textContent='';
      hint.textContent=root.dataset.scratchHint||'';
      a11y.classList.add('ds-show');
    }
    $('ds-unlock').addEventListener('click', doUnlock);
    emailEl.addEventListener('keydown', function(e){ if(e.key==='Enter') doUnlock(); });

    /* ---- SCRATCH CANVAS ---- */
    var ctx, canvas, revealed=false, lastCheck=0;
    function initScratch(){
      canvas=$('ds-foil'); if(!canvas) return;
      var dpr=Math.max(1, window.devicePixelRatio||1);
      var w=stage.clientWidth, h=stage.clientHeight;
      canvas.width=w*dpr; canvas.height=h*dpr;
      ctx=canvas.getContext('2d'); ctx.scale(dpr,dpr);
      var g=ctx.createLinearGradient(0,0,w,h);
      g.addColorStop(0,cfg.foil1); g.addColorStop(.5,cfg.foil2); g.addColorStop(1,cfg.foil1);
      ctx.fillStyle=g; ctx.fillRect(0,0,w,h);
      ctx.fillStyle='rgba(255,255,255,.6)';
      for(var i=0;i<26;i++){ var x=Math.random()*w,y=Math.random()*h,r=Math.random()*1.8+.4; ctx.beginPath();ctx.arc(x,y,r,0,7);ctx.fill(); }
      ctx.globalCompositeOperation='destination-out';

      var drawing=false, last=null;
      function pos(e){ var r=canvas.getBoundingClientRect(); return {x:e.clientX-r.left, y:e.clientY-r.top}; }
      function dab(x,y){ ctx.beginPath(); ctx.arc(x,y,22,0,7); ctx.fill(); }
      function strokeTo(pt){
        if(last){ var dx=pt.x-last.x,dy=pt.y-last.y,d=Math.hypot(dx,dy),n=Math.max(1,d/4);
          for(var i=0;i<n;i++) dab(last.x+dx*i/n, last.y+dy*i/n); }
        dab(pt.x,pt.y); last=pt;
      }
      canvas.addEventListener('pointerdown', function(e){ if(stage.classList.contains('ds-locked'))return; drawing=true; last=null; strokeTo(pos(e)); });
      canvas.addEventListener('pointermove', function(e){ if(!drawing)return; e.preventDefault(); strokeTo(pos(e)); check(); }, {passive:false});
      window.addEventListener('pointerup', function(){ drawing=false; last=null; check(); });
    }
    function check(){
      if(revealed) return;
      var now=Date.now(); if(now-lastCheck<120) return; lastCheck=now;
      var d=ctx.getImageData(0,0,canvas.width,canvas.height).data;
      var clear=0,total=0; for(var i=3;i<d.length;i+=32){ total++; if(d[i]===0) clear++; }
      if(clear/total > cfg.threshold) reveal();
    }
    function reveal(){
      if(revealed) return; revealed=true;
      try{ localStorage.setItem('dose_scratch_done','1'); }catch(e){}
      if(canvas){ canvas.style.transition='opacity .45s'; canvas.style.opacity='0'; setTimeout(function(){ canvas&&canvas.remove(); },460); }
      if(h1 && root.dataset.headingReveal) h1.textContent=root.dataset.headingReveal;
      if(root.dataset.successHint) hint.textContent=root.dataset.successHint;
      actions.classList.add('ds-show'); a11y.classList.remove('ds-show'); burst();
      track('Scratch Popup Revealed','revealed',{code:cfg.code});
    }
    a11y.addEventListener('click', function(){ if(!stage.classList.contains('ds-locked')) reveal(); });

    $('ds-copy').addEventListener('click', function(){
      if(navigator.clipboard) navigator.clipboard.writeText(cfg.code);
      if(root.dataset.copiedLabel) this.textContent=root.dataset.copiedLabel;
      track('Scratch Popup Code Copied','copied',{code:cfg.code});
    });
    $('ds-use').addEventListener('click', function(){
      track('Scratch Popup Code Used','used',{code:cfg.code});
      window.location.href='/discount/'+encodeURIComponent(cfg.code)+'?redirect='+encodeURIComponent(cfg.useUrl);
    });

    function burst(){
      var cols=['#E0496E','#EC8FC0','#8A5CD0','#C77DD6','#F5D06B'];
      for(var i=0;i<34;i++){ var s=document.createElement('i');
        s.style.left=(Math.random()*100)+'%'; s.style.background=cols[i%cols.length];
        s.style.animationDuration=(Math.random()*.8+.9)+'s'; s.style.animationDelay=(Math.random()*.2)+'s';
        s.style.transform='rotate('+(Math.random()*360)+'deg)'; confetti.appendChild(s);
        setTimeout((function(el){return function(){el.remove();};})(s),2200);
      }
    }
  }
  if(document.readyState!=='loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mo = null, deb = 0;
    function $(s, r) { return (r || document).querySelector(s); }
    function num(s) { if (s == null) return null; var n = parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')); return isNaN(n) ? null : n; }
    function moneyInt(n) { return '$' + n.toLocaleString('es-MX'); }
    function perTxt(price, porc, label) { return '$' + (price / porc).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (label || '/ porción'); }
    function cfg() { var e = $('[data-dose-subs-config]'); if (!e) return null; try { return JSON.parse(e.textContent); } catch (x) { return null; } }
    function porcSel() { var b = $('.kaching-bundles__bar--selected'); if (!b) return null; var m = b.textContent.match(/(\d{2,4})\s*porcion/i) || b.textContent.match(/(\d{2,4})/); return m ? parseInt(m[1], 10) : null; }
    function freqTxt() { var e = $('.kaching-subscriptions__dropdown-trigger-label'); return e ? e.textContent.trim() : ''; }
    function childByClass(parent, cls) { return parent ? parent.querySelector(':scope > .' + cls) : null; }
    function mk(tag, cls) { var el = document.createElement(tag); el.className = cls; return el; }

    // Keep a quantity tile sticky: Kaching deselects the tile when you re-click the already-selected
    // bar (→ nothing selected, buy box silently falls back to base 30 porciones). Block just that one
    // interaction in the capture phase so a selected tile stays selected; clicking a DIFFERENT tile is
    // untouched (that bar isn't --selected, so the event passes straight through to Kaching).
    document.addEventListener('click', function (e) {
      var bar = e.target && e.target.closest ? e.target.closest('.kaching-bundles__bar') : null;
      if (bar && bar.classList.contains('kaching-bundles__bar--selected')) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }, true);

    function render() {
      var c = cfg(); if (!c) return;
      var sub = $('.kaching-subscriptions__with-explanation');
      var src = $('[data-dose-subs]');
      if (!sub || !src) return;
      var porc = porcSel();

      if (mo) mo.disconnect();
      try {
        // Ribbon
        if (c.ribbon && c.ribbon.show && c.ribbon.text) sub.setAttribute('data-dose-ribbon', c.ribbon.text);
        else sub.removeAttribute('data-dose-ribbon');

        var priceWrap = $('.ks-price-wrapper', sub);

        // Discount corner badge on the subscribe card ("Ahorra X%", where "Mejor Valor" sat), from
        // Kaching's label. Strip the old inline pill if a prior render added one.
        var label = $('.ks-discount-label', sub);
        var oldPill = childByClass(priceWrap, 'dose-pill');
        if (oldPill) oldPill.remove();
        var m = label ? label.textContent.match(/ahorra\s*\d+\s*%/i) : null;
        if (m) sub.setAttribute('data-dose-disc', m[0].replace(/\s+/g, ' '));
        else sub.removeAttribute('data-dose-disc');

        // $/porción (subscribe)
        if (c.showPerServing && porc && priceWrap) {
          var subNow = num(($('.ks-discounted-price', sub) || {}).textContent);
          if (subNow) {
            var ps = childByClass(priceWrap, 'dose-perserving');
            if (!ps) { ps = mk('div', 'dose-perserving'); priceWrap.appendChild(ps); }
            ps.textContent = perTxt(subNow, porc, c.perServingLabel);
          }
        }

        // Ship line (full-width, after .ks-card-info)
        var card = $('.ks-card', sub), info = $('.ks-card-info', sub);
        if (card && info && porc) {
          var ship = childByClass(card, 'dose-ship-line');
          if (!ship) { ship = src.querySelector('.dose-ship-line').cloneNode(true); info.insertAdjacentElement('afterend', ship); }
          var txt = (c.shipTemplate || '{porciones} porciones enviadas cada {frecuencia}').replace('{porciones}', porc).replace('{frecuencia}', freqTxt());
          ship.querySelector('[data-dose-ship-text]').textContent = txt;
        }

        // Beneficios box (single section-level list, cloned once before the frequency control)
        var fw = $('.ks-features-wrapper', sub);
        if (fw) {
          var active = src.querySelector('.dose-benefits');
          var cur = childByClass(fw, 'dose-benefits');
          if (active && !cur) {
            var clone = active.cloneNode(true);
            var freq = $('.ks-delivery-frequency-wrapper', fw);
            if (freq) fw.insertBefore(clone, freq); else fw.appendChild(clone);
          }
        }

        // One-time: strikethrough + $/porción
        var otWrap = $('.one-time-purchase .kaching-subscriptions__card-price-wrapper');
        if (otWrap) {
          var otNow = num(($('.one-time-purchase .kaching-subscriptions__card-price') || {}).textContent);
          var orig = num(($('.ks-original-price', sub) || {}).textContent);
          var was = childByClass(otWrap, 'dose-ot-was');
          if (orig && otNow && orig > otNow) {
            if (!was) { was = mk('span', 'dose-ot-was'); otWrap.insertBefore(was, otWrap.firstChild); }
            was.textContent = moneyInt(orig);
          } else if (was) { was.remove(); }
          // One-time discount corner badge = (orig − now)/orig; hidden when there's no discount
          var otCard = $('.one-time-purchase');
          if (otCard) {
            if (orig && otNow && orig > otNow) otCard.setAttribute('data-dose-disc', 'Ahorra ' + Math.round((orig - otNow) / orig * 100) + '%');
            else otCard.removeAttribute('data-dose-disc');
          }
          if (c.showPerServing && otNow && porc) {
            var ops = childByClass(otWrap, 'dose-perserving');
            if (!ops) { ops = mk('div', 'dose-perserving'); otWrap.appendChild(ops); }
            ops.textContent = perTxt(otNow, porc, c.perServingLabel);
          }
        }

        // Tile pills + tile-price hide are now PURE CSS (the kaching-bundles-block rules in the
        // stylesheet) — they paint correct on Kaching's first frame with no JS. Nothing to do here.
      } finally {
        observe();
      }
    }

    function observe() {
      var w = $('.kaching-subscriptions__cards-wrapper') || $('kaching-subscriptions-block');
      if (!w) return;
      mo = new MutationObserver(function () { if (deb) return; deb = requestAnimationFrame(function () { deb = 0; render(); }); });
      mo.observe(w, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      var b = $('.kaching-bundles');
      if (b) mo.observe(b, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if ($('.kaching-subscriptions__cards-wrapper')) { clearInterval(iv); render(); }
      else if (tries > 80) clearInterval(iv);
    }, 250);
  })();

  /* ===== Quantity-tile badges ("Más Vendido" / "Mejor Valor") =====
     Adds a top-center badge to the tile whose porciones matches a configured badge. Self-contained and
     independent of the subscribe card, so it also paints on products that have quantity tiles but no
     subscription option. Matches by porciones (robust to tile order/count); text + color come from the
     section settings JSON. Observes class/childList only (not attributes), so setting the badge's inline
     color never re-triggers it — no loop. */
  (function () {
    var cfgEl = document.querySelector('[data-dose-subs-config]');
    if (!cfgEl) return;
    var badges = [];
    try { badges = (JSON.parse(cfgEl.textContent).badges || []).filter(function (b) { return b && b.text && b.porciones; }); }
    catch (e) { return; }
    var deb = 0;
    function num(s) { if (s == null) return null; var n = parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')); return isNaN(n) ? null : n; }
    function porcOf(bar) { var m = bar.textContent.match(/(\d{2,4})\s*porcion/i) || bar.textContent.match(/(\d{2,4})/); return m ? parseInt(m[1], 10) : null; }
    function paint() {
      document.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        // "Más Vendido" / "Mejor Valor" badge (top-center)
        var p = porcOf(bar), hit = null;
        badges.forEach(function (b) { if (parseInt(b.porciones, 10) === p) hit = b; });
        var el = bar.querySelector(':scope > .dose-tile-badge');
        if (hit) {
          if (!el) { el = document.createElement('span'); el.className = 'dose-tile-badge'; bar.appendChild(el); }
          if (el.textContent !== hit.text) el.textContent = hit.text;
          if (hit.color) el.style.background = hit.color;
        } else if (el) { el.remove(); }

        // "Ahorra $X" peso pill = full-price − now-price. No discount (now == full) → hide the crossed
        // price (don't strike the same number) and drop the pill. So 30 porciones shows one clean price.
        var pricing = bar.querySelector('.kaching-bundles__bar-pricing');
        if (pricing) {
          var nowEl = pricing.querySelector('.kaching-bundles__bar-price');
          var fullEl = pricing.querySelector('.kaching-bundles__bar-full-price');
          var now = num(nowEl && nowEl.textContent), full = num(fullEl && fullEl.textContent);
          var ah = pricing.querySelector(':scope > .dose-tile-ahorra');
          if (now != null && full != null && full > now) {
            if (fullEl) fullEl.style.display = '';
            var txt = 'Ahorra $' + Math.round(full - now).toLocaleString('es-MX');
            if (!ah) { ah = document.createElement('span'); ah.className = 'dose-tile-ahorra'; pricing.appendChild(ah); }
            if (ah.textContent !== txt) ah.textContent = txt;
          } else {
            if (fullEl) fullEl.style.display = 'none';
            if (ah) ah.remove();
          }
        }
      });
    }
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (document.querySelector('.kaching-bundles__bar')) { clearInterval(iv); paint(); }
      else if (tries > 80) clearInterval(iv);
    }, 250);
    var root = document.querySelector('.kaching-bundles') || document.body;
    var mo = new MutationObserver(function () { if (deb) return; deb = requestAnimationFrame(function () { deb = 0; paint(); }); });
    mo.observe(root, { subtree: true, childList: true, characterData: true });
  })();

  /* ===== Mundial promo widget =====
     Inserts the widget directly BELOW the "Agregar al carrito" button (afterend of
     .product__submit__buttons — a stable theme class, not Kaching-dependent) and keeps its price
     math live off Kaching's own rendered one-time price: promo = one-time price × (1 − pct/100).
     Hides the deal when the subscription card is selected (code is one-time-only at checkout).
     The copy control is type="button" so it never submits the surrounding product form.
     Self-contained; if the template is absent (setting off) or the anchor never renders, nothing
     happens. Fallback anchor: above the quantity tiles, so the promo still shows if the theme
     button class ever changes. */
  (function () {
    var tpl = document.querySelector('[data-dose-mundial-tpl]');
    if (!tpl || !('content' in tpl)) return;
    var widget = null, deb = 0;

    function num(s) { if (s == null) return null; var n = parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')); return isNaN(n) ? null : n; }
    function money(n) { return '$' + n.toLocaleString('es-MX', { minimumFractionDigits: (n % 1 ? 2 : 0), maximumFractionDigits: 2 }); }

    function place() {
      if (widget) return true;
      var btn = document.querySelector('.product__submit__buttons');
      var anchor = btn || document.querySelector('kaching-bundles-block');
      if (!anchor) return false;
      widget = tpl.content.firstElementChild.cloneNode(true);
      anchor.insertAdjacentElement(btn ? 'afterend' : 'beforebegin', widget);
      wireCopy();
      return true;
    }

    function oneTimeSelected() {
      var ot = document.querySelector('.kaching-subscriptions__card-wrapper.one-time-purchase');
      if (!ot) return true; /* sub cards not rendered (or product has none) -> treat as one-time */
      return ot.classList.contains('selected');
    }

    function currentPrice() {
      /* primary: Kaching's one-time card price (already tier-discounted) */
      var el = document.querySelector('.one-time-purchase .kaching-subscriptions__card-price');
      var n = el ? num(el.textContent) : null;
      if (n) return n;
      /* fallback: selected tile's own (CSS-hidden) pricing text — first $ amount is the current price */
      var bar = document.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-pricing');
      if (bar) { var m = bar.textContent.match(/\$\s*[\d.,]+/); if (m) return num(m[0]); }
      return null;
    }

    function update() {
      if (!place()) return;
      var sub = !oneTimeSelected();
      widget.classList.toggle('dose-mundial--sub', sub);
      if (sub) return;
      var pct = parseFloat(widget.getAttribute('data-pct')) || 15;
      var p = currentPrice();
      if (!p) { widget.classList.remove('dose-mundial--priced'); return; }
      var promo = Math.round(p * (100 - pct)) / 100;
      widget.querySelector('[data-mundial-was]').textContent = money(p);
      widget.querySelector('[data-mundial-now]').textContent = money(promo);
      widget.classList.add('dose-mundial--priced');
    }

    function wireCopy() {
      var btn = widget.querySelector('[data-mundial-copy]');
      var hint = widget.querySelector('[data-mundial-hint]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = widget.getAttribute('data-code') || '';
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code);
        btn.classList.add('is-copied');
        if (hint) hint.textContent = hint.getAttribute('data-copied') || hint.textContent;
        setTimeout(function () {
          btn.classList.remove('is-copied');
          if (hint) hint.textContent = hint.getAttribute('data-hint') || '';
        }, 2200);
      });
    }

    /* poll until placed+priced (Kaching renders client-side), then mutations keep it live */
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      update();
      if ((widget && widget.classList.contains('dose-mundial--priced')) || tries > 120) clearInterval(iv);
    }, 250);
    var mo = new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(update, 200); });
    mo.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  })();

  /* ===== Sticky add-to-cart (DOSE custom, IM8-style drop-up) =====
     Mirrors the buy box: porciones tile + compra única/suscripción + price.
     Reads everything live from the Kaching widget, so it works on every product.
     The real "Agregar al carrito" button does the actual add (respects the selected format). */
  (function () {
    if (window.__doseSatc) return; window.__doseSatc = true;

    var CSS = [
      '.dsatc{position:fixed;left:0;right:0;bottom:0;z-index:9990;transform:translateY(130%);transition:transform .28s cubic-bezier(.2,.8,.2,1);pointer-events:none;background:rgba(255,255,255,.975);-webkit-backdrop-filter:saturate(140%) blur(8px);backdrop-filter:saturate(140%) blur(8px);border-top:1px solid #ece7e0;box-shadow:0 -10px 34px rgba(20,15,10,.10)}',
      '.dsatc.on{transform:translateY(0);pointer-events:auto}',
      '.dsatc__bar{max-width:520px;margin:0 auto;padding:10px 14px calc(10px + env(safe-area-inset-bottom));display:flex;gap:9px;align-items:stretch}',
      '.dsatc__pill{flex:1 1 auto;min-width:0;text-align:left;background:#fff;border:1.6px solid #e7ddd3;border-radius:15px;padding:7px 12px;display:flex;align-items:center;gap:10px;cursor:pointer;font-family:inherit;color:#1a1513}',
      '.dsatc__pill.open{border-color:#e11414;box-shadow:0 0 0 3px rgba(225,20,20,.10)}',
      '.dsatc__tx{flex:1;min-width:0;display:flex;flex-direction:column}',
      '.dsatc__l1{font-weight:700;font-size:14.5px;line-height:1.15;display:flex;align-items:center;gap:7px}',
      '.dsatc__tag{font-size:9.5px;font-weight:800;letter-spacing:.3px;color:#fff;background:#6d3bd6;padding:2px 7px;border-radius:99px;text-transform:uppercase;white-space:nowrap}',
      '.dsatc__l2{font-size:12px;color:#7a7269;margin-top:1px;font-weight:600}',
      '.dsatc__l2 b{color:#1a1513;font-weight:700}.dsatc__l2 .d{color:#1a8f4a;font-weight:700}',
      '.dsatc__car{flex:none;font-size:12px;color:#e11414;transition:transform .22s;line-height:1}',
      '.dsatc__pill.open .dsatc__car{transform:rotate(180deg)}',
      '.dsatc__add{flex:0 0 auto;background:#ED2232;color:#fff;border:none;border-radius:300px;font-family:inherit;font-weight:700;font-size:15px;letter-spacing:.3px;padding:0 24px;cursor:pointer;white-space:nowrap;transition:transform .08s}',
      '.dsatc__add:active{transform:scale(.97)}',
      '.dsatc__menu{position:fixed;left:50%;transform:translateX(-50%) translateY(12px);width:calc(100% - 24px);max-width:496px;bottom:70px;background:#fff;border:1px solid #efe7dd;border-radius:18px;box-shadow:0 18px 50px rgba(20,15,10,.22);overflow:hidden;z-index:9991;opacity:0;visibility:hidden;pointer-events:none;transition:opacity .2s,transform .22s cubic-bezier(.2,.8,.2,1)}',
      '.dsatc__menu.on{opacity:1;visibility:visible;pointer-events:auto;transform:translateX(-50%) translateY(0)}',
      '.dsatc__hd{font-size:11px;letter-spacing:1.3px;font-weight:700;color:#7a7269;padding:13px 16px 7px;text-transform:uppercase;display:flex;justify-content:space-between}',
      '.dsatc__hd .f{color:#6d3bd6;font-weight:800}',
      '.dsatc__opt{display:flex;align-items:center;gap:12px;padding:12px 16px;cursor:pointer;border-top:1px solid #f3ece3}',
      '.dsatc__opt:hover{background:#faf6f0}',
      '.dsatc__rd{flex:none;width:20px;height:20px;border-radius:50%;border:2px solid #d7cabb;display:grid;place-items:center}',
      '.dsatc__opt.sel .dsatc__rd{border-color:#e11414;background:#e11414}',
      '.dsatc__ck{color:#fff;font-size:12px;font-weight:900;opacity:0;line-height:1}.dsatc__opt.sel .dsatc__ck{opacity:1}',
      '.dsatc__om{flex:1;min-width:0;display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}',
      '.dsatc__ot{font-weight:700;font-size:15px}',
      '.dsatc__od{font-size:12px;font-weight:700;color:#1a8f4a}.dsatc__od.none{color:#7a7269;font-weight:600}',
      '.dsatc__op{text-align:right;flex:none}',
      '.dsatc__on{font-weight:800;font-size:15.5px;color:#e11414}',
      '.dsatc__ow{font-size:11.5px;color:#a89c8d;text-decoration:line-through;font-weight:600}',
      '.dsatc__scrim{position:fixed;inset:0;background:rgba(20,15,10,.18);opacity:0;visibility:hidden;transition:opacity .2s;z-index:9989}',
      '.dsatc__scrim.on{opacity:1;visibility:visible}'
    ].join('');
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);

    function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
    function money(n) { return '$' + Math.round(n).toLocaleString('es-MX'); }
    function toNum(s) { return parseFloat(('' + s).replace(/[^0-9.,]/g, '').replace(/,/g, '')) || 0; }
    function pct(now, was) { return was > 0 ? Math.round((1 - now / was) * 100) : 0; }

    var scrim = el('div', 'dsatc__scrim');
    var menu = el('div', 'dsatc__menu');
    var hd = el('div', 'dsatc__hd'); hd.appendChild(el('span', null, 'Elige la cantidad')); var hdF = el('span', 'f'); hd.appendChild(hdF); menu.appendChild(hd);
    var optBox = el('div'); menu.appendChild(optBox);
    var root = el('div', 'dsatc'); var bar = el('div', 'dsatc__bar');
    var pill = el('button', 'dsatc__pill'); pill.type = 'button';
    var tx = el('span', 'dsatc__tx'); var l1 = el('span', 'dsatc__l1'); var l2 = el('span', 'dsatc__l2'); tx.appendChild(l1); tx.appendChild(l2);
    pill.appendChild(tx); pill.appendChild(el('span', 'dsatc__car', '▼'));
    var add = el('button', 'dsatc__add', 'AGREGAR'); add.type = 'button';
    bar.appendChild(pill); bar.appendChild(add); root.appendChild(bar);
    document.body.appendChild(scrim); document.body.appendChild(menu); document.body.appendChild(root);

    function findAtc() {
      var bs = [].slice.call(document.querySelectorAll('button, input[type="submit"], [role="button"]')), hit = null;
      for (var i = 0; i < bs.length; i++) { var t = (bs[i].textContent || bs[i].value || ''); if (/agregar al carrito/i.test(t)) { if (bs[i].offsetParent !== null) return bs[i]; if (!hit) hit = bs[i]; } }
      return hit;
    }
    function subSelected() {
      var ot = document.querySelector('.kaching-subscriptions__card-wrapper.one-time-purchase');
      return ot ? !ot.classList.contains('selected') : false;
    }
    function readTiers() {
      var out = [];
      [].slice.call(document.querySelectorAll('.kaching-bundles__bar')).forEach(function (b) {
        var txt = (b.textContent || '').replace(/\s+/g, ' ').trim();
        var pm = txt.match(/(\d{2,4})\s*porcion/i) || txt.match(/(\d{2,4})/); if (!pm) return;
        var pxt = txt.replace(/ahorra\s*\$\s*[\d.,]+/ig, ' '); /* strip "Ahorra $X" (savings) so it isn't parsed as the price */
        var ps = (pxt.match(/\$\s*[\d.,]+/g) || []).map(toNum).filter(function (n) { return n > 0; });
        out.push({ porc: parseInt(pm[1], 10), now: ps.length ? Math.min.apply(null, ps) : 0, was: ps.length > 1 ? Math.max.apply(null, ps) : null, bar: b, sel: b.classList.contains('kaching-bundles__bar--selected') });
      });
      return out;
    }
    function subFactor(tiers, sel) {
      var sc = document.querySelector('.kaching-subscriptions__with-explanation'); if (!sc || sel < 0) return null;
      var ps = (sc.textContent.match(/\$\s*[\d.,]+/g) || []).map(toNum).filter(function (n) { return n > 0; });
      if (!ps.length || !tiers[sel] || !tiers[sel].now) return null;
      return Math.min.apply(null, ps) / tiers[sel].now;
    }

    var S = { tiers: [], sel: 0, sub: false };
    function compute() {
      var tiers = readTiers(), sel = 0; tiers.forEach(function (t, i) { if (t.sel) sel = i; });
      var sub = subSelected(), f = sub ? subFactor(tiers, sel) : null, showSub = !!(sub && f);
      tiers.forEach(function (t) {
        var reg = t.was || t.now;
        if (showSub) { t.dn = t.now * f; t.dw = reg; t.off = pct(t.dn, reg); }
        else { t.dn = t.now; t.dw = t.was; t.off = t.was ? pct(t.now, t.was) : 0; }
      });
      S.tiers = tiers; S.sel = sel; S.sub = showSub;
    }
    function renderPill() {
      var t = S.tiers[S.sel]; if (!t) return;
      l1.textContent = ''; l1.appendChild(document.createTextNode(t.porc + ' Porciones'));
      if (S.sub) l1.appendChild(el('span', 'dsatc__tag', 'Suscripción'));
      l2.textContent = ''; l2.appendChild(el('b', null, money(t.dn)));
      if (t.off > 0) { l2.appendChild(document.createTextNode(' · ')); l2.appendChild(el('span', 'd', 'Ahorra ' + t.off + '%')); }
    }
    function renderMenu() {
      hdF.textContent = S.sub ? 'Suscripción' : '';
      optBox.textContent = '';
      S.tiers.forEach(function (t, i) {
        var row = el('div', 'dsatc__opt' + (i === S.sel ? ' sel' : ''));
        var rd = el('span', 'dsatc__rd'); rd.appendChild(el('span', 'dsatc__ck', '✓')); row.appendChild(rd);
        var om = el('span', 'dsatc__om'); om.appendChild(el('span', 'dsatc__ot', t.porc + ' Porciones'));
        om.appendChild(el('span', 'dsatc__od' + (t.off > 0 ? '' : ' none'), t.off > 0 ? ('Ahorra ' + t.off + '%') : 'Precio regular'));
        row.appendChild(om);
        var op = el('span', 'dsatc__op'); op.appendChild(el('div', 'dsatc__on', money(t.dn)));
        if (t.dw) op.appendChild(el('div', 'dsatc__ow', money(t.dw)));
        row.appendChild(op);
        row.onclick = function () { pick(i); };
        optBox.appendChild(row);
      });
    }
    function refresh() { compute(); renderPill(); if (isOpen()) renderMenu(); }
    function isOpen() { return menu.classList.contains('on'); }
    function openMenu() { renderMenu(); menu.classList.add('on'); scrim.classList.add('on'); pill.classList.add('open'); }
    function closeMenu() { menu.classList.remove('on'); scrim.classList.remove('on'); pill.classList.remove('open'); }
    function pick(i) {
      var t = S.tiers[i];
      if (t && t.bar && !t.bar.classList.contains('kaching-bundles__bar--selected')) {
        (t.bar.querySelector('.kaching-bundles__bar-main') || t.bar.querySelector('label') || t.bar).click();
      }
      closeMenu(); setTimeout(refresh, 280);
    }

    pill.addEventListener('click', function () { isOpen() ? closeMenu() : (refresh(), openMenu()); });
    scrim.addEventListener('click', closeMenu);
    add.addEventListener('click', function () { var a = findAtc(); if (a) { closeMenu(); a.click(); } });

    function wireShow() {
      var atc = findAtc(); if (!atc) return false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { var past = !e.isIntersecting && e.boundingClientRect.top < 0; root.classList.toggle('on', past); if (!past) closeMenu(); });
      }, { threshold: 0 }).observe(atc);
      return true;
    }
    function wireSync() {
      var deb, mo = new MutationObserver(function () { clearTimeout(deb); deb = setTimeout(refresh, 220); });
      var a = document.querySelector('.kaching-bundles'); if (a) mo.observe(a, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true, characterData: true });
      var b = document.querySelector('.kaching-subscriptions__cards-wrapper'); if (b) mo.observe(b, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    var tries = 0, iv = setInterval(function () {
      tries++;
      if (document.querySelector('.kaching-bundles__bar') && findAtc()) { clearInterval(iv); compute(); renderPill(); wireShow(); wireSync(); }
      else if (tries > 100) clearInterval(iv);
    }, 200);
  })();

  } catch(e) { console.error(e); }
})();
})();
